export default __webpack_public_path__ + "static/media/alert_success.68dc15d6.svg";